import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { TransactionListResp } from 'domain/payload/response/transaction/TransactionListResp';
import { TransactionDetailResp } from 'domain/payload/response/transaction/TransactionDetailResp';

const TransactionService = () => {
  const transactionList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null,
    startDate: string | null,
    endDate: string | null,
  ): Promise<BaseResponse<TransactionListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/transaction/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size,
          startDate: startDate,
          endDate: endDate,
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const transactionDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<TransactionDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/transaction/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const transactionExportToCsv = async (
    token: string,
    search: string | null,
    startDate: string | null,
    endDate: string | null,
) => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/transaction/exportToCsv`, {}, { 
        responseType: "blob",       
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        params: {
          search,
          startDate: startDate,
          endDate: endDate,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const transactionDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/transaction/delete`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { id },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { transactionList, transactionDetail, transactionExportToCsv, transactionDelete };
};

export default TransactionService;